import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spin } from "antd";
import { ToolbarButton } from "./toolbarButton.js";
import { useFolderTreeRuntime } from "../../contexts/folderTreeRuntime.js";
import { LegacyIcon } from "../common/legacyIcon.js";
const resolveToolbarButton = (buttonKey, descriptor, resolveBuiltInToolbarAction)=>{
    if (descriptor.action && descriptor.action !== "custom") {
        const { action: _action, ...presentation } = descriptor;
        return {
            ...presentation,
            ...resolveBuiltInToolbarAction?.(descriptor.action, buttonKey) ?? {}
        };
    }
    const { action: _action, ...rest } = descriptor;
    return rest;
};
const ToolbarButtonResolved = ({ buttonKey, descriptor, disabled })=>{
    const { resolveBuiltInToolbarAction } = useFolderTreeRuntime();
    const resolved = resolveToolbarButton(buttonKey, descriptor, resolveBuiltInToolbarAction);
    return /*#__PURE__*/ _jsx(ToolbarButton, {
        ...resolved,
        disabled: disabled ? true : resolved.disabled
    }, buttonKey);
};
const Toolbar = ({ isToolbarActive, isToolbarBusy, buttons = {}, backButton = {
    label: "Cancel"
}, activeButton, checkedNodes = [], onCloseMultiToolbar })=>{
    const { resolveBuiltInToolbarAction } = useFolderTreeRuntime();
    const handleCancelClick = (cancelNode)=>{
        if (!activeButton) {
            return;
        }
        const descriptor = buttons[activeButton];
        if (!descriptor || typeof descriptor !== "object") {
            return;
        }
        const resolved = resolveToolbarButton(activeButton, descriptor, resolveBuiltInToolbarAction);
        resolved.onCancel?.(cancelNode, resolved);
    };
    const activeButtonDescriptor = activeButton ? buttons[activeButton] : undefined;
    const activeButtonConfig = activeButtonDescriptor && typeof activeButtonDescriptor === "object" ? resolveToolbarButton(activeButton, activeButtonDescriptor, resolveBuiltInToolbarAction) : undefined;
    const hasActionButtonSave = activeButtonConfig?.onSave;
    const activeActions = [];
    if (activeButton) {
        activeActions.push(/*#__PURE__*/ _jsx(ToolbarButton, {
            content: backButton.label,
            onClick: handleCancelClick
        }, "activeButtonCancel"));
    }
    if (hasActionButtonSave) {
        activeActions.push(/*#__PURE__*/ _jsx(ToolbarButton, {
            content: backButton.save,
            onClick: hasActionButtonSave
        }, "activeButtonSave"));
    }
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: isToolbarBusy,
        size: "small",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "aiot-toolbar",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "aiot-toolbar-items",
                    children: [
                        activeButton ? activeActions : Object.entries(buttons).map(([key, descriptor])=>{
                            if (!descriptor) {
                                return null;
                            }
                            return /*#__PURE__*/ _jsx(ToolbarButtonResolved, {
                                buttonKey: key,
                                descriptor: descriptor,
                                disabled: !isToolbarActive ? true : descriptor.disabled
                            }, key);
                        }),
                        checkedNodes.length > 0 && [
                            /*#__PURE__*/ _jsx(ToolbarButton, {
                                cssClasses: "aiot-border-left",
                                disabled: true,
                                content: /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        /*#__PURE__*/ _jsx(LegacyIcon, {
                                            type: "check"
                                        }),
                                        " ",
                                        checkedNodes.length
                                    ]
                                })
                            }, "multiple-count"),
                            /*#__PURE__*/ _jsx(ToolbarButton, {
                                content: /*#__PURE__*/ _jsx(LegacyIcon, {
                                    type: "close"
                                }),
                                onClick: onCloseMultiToolbar
                            }, "multiple-close")
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "clear"
                })
            ]
        })
    });
};
export { Toolbar };
